// removed by extract-text-webpack-plugin
module.exports = {"section":"src-pages----about-module---section---joRXC","content":"src-pages----about-module---content---1y3Xq","smallCaps":"src-pages----about-module---smallCaps---3wc7F","pointers":"src-pages----about-module---pointers---1ts53","icon":"src-pages----about-module---icon----oEps","tools":"src-pages----about-module---tools---3cS3j"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/about.module.scss
// module id = 565
// module chunks = 263791100135453